import { useFormController } from '@dreryk/react-common';
import { Checkbox, FormController, StyledMargin, TextView } from '@dreryk/react-components';

import { serviceProvidingLocationTranslationKeys } from '../../../../translations';
import { Form } from '../../../common/Form/Form';
import { HealthcarePracticeFormBean } from '../../common/healthcarePractice';
import { ServiceProvidingLocationFormBean } from '../../common/serviceProvidingLocation';
import { useServiceProvidingLocationUpdateModalDirtyStateUpdate } from '../ServiceProvidingLocationUpdateModal.state';
import { ServiceProvidingLocationUpdateUsingPracticeDataFormPart } from '../ServiceProvidingLocationUpdateUsingPracticeDataFormPart';
import { ServiceProvidingLocationUsingOwnDataUpdateFormPart } from '../ServiceProvidingLocationUsingOwnDataUpdateFormPart';

import { MedicalFieldAutosuggest } from './fields/MedicalFieldAutosuggest';
import { StyledServiceProvidingLocationDataFormSection } from './ServiceProvidingLocationUpdateForm.styled';

type ServiceProvidingLocationUpdateFormProps = {
   readonly healthcarePractice: HealthcarePracticeFormBean;
   readonly serviceProvidingLocation: ServiceProvidingLocationFormBean;
   readonly onUpdate: (formData: ServiceProvidingLocationFormBean) => Promise<void>;
};

export const ServiceProvidingLocationUpdateForm = (props: ServiceProvidingLocationUpdateFormProps): JSX.Element => {
   const { watch, formState, register, handleSubmit } = useFormController<ServiceProvidingLocationFormBean>(
      props.serviceProvidingLocation
   );

   useServiceProvidingLocationUpdateModalDirtyStateUpdate('updateForm', formState.isDirty);
   const usingHealthcarePracticeDetails = watch('usingHealthcarePracticeDetails');

   return (
      <Form>
         <Form.Section
            testId={'serviceProvidingLocationData'}
            heading={serviceProvidingLocationTranslationKeys.serviceProvidingLocationData}
         >
            <StyledServiceProvidingLocationDataFormSection>
               <TextView label={serviceProvidingLocationTranslationKeys.locationCode} testId={'locationCode'}>
                  {props.serviceProvidingLocation.locationCode}
               </TextView>

               <StyledMargin top={12}>
                  <MedicalFieldAutosuggest name={'medicalField'} register={register} />
               </StyledMargin>
            </StyledServiceProvidingLocationDataFormSection>
         </Form.Section>

         <Form.Section
            testId={'nameAndContactData'}
            heading={serviceProvidingLocationTranslationKeys.nameAndContactData}
         >
            <Checkbox
               testId={'usingHealthcarePracticeDetails'}
               label={serviceProvidingLocationTranslationKeys.usingHealthcarePracticeDetails}
               controller={register('usingHealthcarePracticeDetails')}
            />
            <FormController controller={register('id')} />
            <FormController
               controller={register('locationCode', {
                  required: true,
               })}
            />
            {usingHealthcarePracticeDetails ? (
               <ServiceProvidingLocationUpdateUsingPracticeDataFormPart
                  healthcarePractice={props.healthcarePractice}
                  onUpdate={handleSubmit(props.onUpdate)}
               />
            ) : (
               <ServiceProvidingLocationUsingOwnDataUpdateFormPart
                  register={register}
                  formState={formState}
                  onUpdate={handleSubmit(props.onUpdate)}
               />
            )}
         </Form.Section>
      </Form>
   );
};
